import { clouseauV2 } from '~/services/serviceInstances';

import { ListExtractedClausesApiResponse } from '../types/clouseau/clauses';

export const fetchClauseTypes =
  async (): Promise<ListExtractedClausesApiResponse> => {
    return clouseauV2.get('/clauses/extracted', {});
  };
